'use strict';

var plugins = require('../plugins/');

plugins.forEach(function (plugin) {
    global.hysdk.plugin(plugin);
});


//////////////////
// WEBPACK FOOTER
// ./hysdk.fusion.js
// module id = 32
// module chunks = 1 4